import React, {memo} from 'react';
import PropTypes from 'prop-types';

import { Header } from 'semantic-ui-react'
import { ResponsiveLine } from '@nivo/line'
import { formatNumber } from 'humanize-plus';
import { sortBy } from 'lodash'

const Chip = ({ color }) => (
  <span style={{ display: 'block', width: '12px', height: '12px', background: color }} />
)

// From Nivo Source, without hooks
const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
}
const TableTooltip = memo(({ title, rows }) => {

  if (!rows.length) return null;
  let content;

  content = (
    <div>
      <h3 style={{textAlign: 'left'}}>{title && title}</h3>
      <table style={{ ...tableStyle,  }}>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row[1]}>
              {row.map((column, j) => (
                <td key={j}>
                  {column}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  return <div>{content}</div>
})

const LinePointTooltip = (event) => {
  const {id: year, data} = event;
  let rows = sortBy(data, point => point.data.y).map(point => [
    <Chip key="chip" color={point.serie.color} />,
    point.serie.id,
    <strong key="value">{formatNumber(point.data.y, 6)}</strong>,
  ]).reverse();
  return (
    <TableTooltip
      title={year}
      rows={rows}
    />
  )
}



// Note this linechart actually has a header and wrapper container coupled into it
const LineChart = (props) => {
  const legends = [
    {
      "anchor": "bottom-left",
      "direction": "row",
      "justify": false,
      "translateY": 80,
      "itemsSpacing": 0,
      "itemDirection": "right-to-left",
      "itemWidth": 100,
      "itemHeight": 20,
      "itemOpacity": 0.75,
      "symbolSize": 12,
      "symbolShape": "square",
      "symbolBorderColor": "rgba(0, 0, 0, .5)"
    }
  ];

  // TODO: cleaner way to only display half of the point ticks
  const firstSeries = props.data[0].data;
  let halfTicks;
  if (firstSeries) {
    const allTicks = firstSeries.map(points => points.x);
    halfTicks = allTicks.filter((_, index) => {
      return index % 2 === 0;
    });
  }

  const chartConfig = {
    data: props.data,
    margin: {
      "top": 5,
      "right": 15,
      "bottom": 80,
      "left": 60
    },
    xScale: {
      "type": "point"
    },
    yScale: {
      "type": "linear",
      "stacked": false,
      "min": 0,
      "max": "auto"
    },
    axisBottom: {
      "orient": "bottom",
      "tickSize": 0,
      "tickPadding": 25, // strike against.. can't control tick count
      "legend": "Year",
      "legendOffset": 52,
      "legendPosition": "center",
      tickValues: halfTicks,
    },
    axisLeft: {
      "orient": "left",
      "tickSize": 0,
      "tickRotation": 0,
      "legend": props.yAxisLabel,
      "legendOffset": -40,
      "legendPosition": "center"
    },
    colorBy: (x) => x.color,
    enableGridX: false,
    enableGridY: false,
    enableArea: true,
    enableSlices: false,
    areaOpacity: .50,
    enableDots: false,
    legends,
    tooltip: LinePointTooltip,
    // Motion details
    motionStiffness:90,
    motionDamping:15
  }

  return (
    // Responsive line requires parent to have height
  <div style={{ height: props.containerHeight }}>
    <Header as='h4'>{props.title}</Header>
    <ResponsiveLine {...chartConfig} />
  </div>
  );
}

const LinePointType = PropTypes.shape({
  'x': PropTypes.number.isRequired,
  'y': PropTypes.number.isRequired,
})

const LineSeriesType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(LinePointType).isRequired,
});

LineChart.propTypes = {
  data: PropTypes.arrayOf(LineSeriesType),
  title: PropTypes.string.isRequired,
  containerHeight: PropTypes.string.isRequired, // e.g. 500px
  yAxisLabel: PropTypes.string, // e.g. 500px
}

export default LineChart;



// WEBPACK FOOTER //
// ./src/components/lineChart/index.js